/**
 * Simple bulk
 * @type {[type]}
 */
var Marionette = require('marionette')
var Backbone = require('backbone')
var App = require('app')
var _ = require('lodash')

var Pagination = Marionette.View.extend({
  template: require('./templates/pagination.html'),
  tagName: 'ul',
  className: 'm-pagination pagination',
  initialize: function () {
    var self = this
    this.listenTo(this.options.collection, 'sync', this.render)
  },
  events: {
    'click .js-next-page': 'onNextPage',
    'click .js-prev-page': 'onPrevPage',
    'click .js-goto-page': 'onGotoPage'
  },
  onNextPage: function () { this.options.collection.getNextPage() },
  onPrevPage: function () { this.options.collection.getPreviousPage() },
  onGotoPage: function (ev) {
    var page = parseInt(ev.currentTarget.getAttribute('data-page')) || 0
    this.options.collection.getPage(page)
  },
  templateContext: function () {
    var self = this
    var midSectionSize = 5

    // console.log(self)
    return {
      paginationItems: function () {
        var state = self.options.collection.state
        var paginationItems = []

        var currentPage = self.options.collection.state.currentPage
        var totalPages = self.options.collection.state.totalPages
        var midSectionHalf = Math.floor(midSectionSize / 2)

        var createPage = function (page) {
          return {
            type: 'page',
            value: page,
            current: (currentPage === page)
          }
        }

        var createSeperator = function () {
          return {
            type: 'seperator'
          }
        }

        // first section
        paginationItems.push(createPage(0))
          // middle section

        if (totalPages > midSectionSize + 2) {
          if (totalPages > midSectionSize && currentPage >= midSectionSize) {
            paginationItems.push(createSeperator())
          }

          if (currentPage >= (totalPages - midSectionSize)) {
            var midSectionRange = _.range((totalPages - midSectionSize) - 1, totalPages - 1)
          } else if (currentPage >= midSectionSize) {
            var midSectionStart = currentPage - midSectionHalf
            var midSectionRange = _.range(midSectionStart, (midSectionStart + midSectionSize))
          } else {
            var midSectionRange = _.range(1, 1 + midSectionSize)
          }

          _.forEach(midSectionRange, function (page) {
            paginationItems.push(createPage(page))
          })

        // last section
          if (totalPages > midSectionSize && currentPage < (totalPages - midSectionSize)) {
            paginationItems.push(createSeperator())
          }

        // when there are just a few pages
        } else {
          var midSectionRange = _.range(1, totalPages - 1)
          _.forEach(midSectionRange, function (page) {
            paginationItems.push(createPage(page))
          })
        }

        paginationItems.push(createPage(totalPages - 1))

        return paginationItems
      },
      getState: function () {
        return self.options.collection.state
      },
      hasPrevPage: function () {
        return self.options.collection.hasPreviousPage()
      },
      hasNextPage: function () {
        return self.options.collection.hasNextPage()
      },
      currentPage: function () {
        return self.options.collection.state.currentPage
      },
      getTotalPages: function () {
        return self.options.collection.state.totalPages
      // / if (!_.has(self.options, 'collection.state')) return false
      // return _.get(self.options, 'collection.state.totalPages')
      },
      showBulkToolbar: function () {
        if (self.collection.where({'_bulk': true}).length > 0) return true
        return false
      },
      getBulkCount: function () {
        return self.collection.where({'_bulk': true}).length
      },
      getBulkActions: function () {
        var actions = _.pickBy(self.options.bulkActions, function (o) {
          return App.session.user.hasRole(o.roles)
        })

        return actions
      }
    }
  }
})

var PaginationBehavior = Marionette.Behavior.extend({
  defaults: {
  },
  initialize: function (options) {
  },
  events: {
    'click .js-apply-bulk': 'onBulkApply'
  },
  onRender: function () {
    var self = this
    // only show the pagination when the collection has a state which means that this is a pagination collection
    if (_.get(self.view.options.collection, 'state')) {
      this.view.showChildView('collection_pagination', new Pagination(self.view.options))
    }
  }
})

module.exports = PaginationBehavior



// WEBPACK FOOTER //
// ./js/behaviors/collection_pagination/index.js